// This file is AUTOGENERATED, do not edit it manually!!!

export const users = {};
